export const formatDifferencePercentageBetweenValues = (
  newValue: number,
  oldValue: number,
  maximumFractionDigits = 2
) => {
  const difference = oldValue - newValue
  const percentageDiff = (difference / oldValue) * 100

  return `${percentageDiff.toFixed(maximumFractionDigits)}`
}
